import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b5977da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0b5977da&prod&lang=scss"
import style1 from "./index.scss?vue&type=style&index=1&id=0b5977da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5977da",
  null
  
)

export default component.exports